import { ClassroomService, classroomManager } from 'sat-core';

ClassroomService.joinClassroom = async (code, addTeacher = true) => classroomManager.joinClassroom(code, addTeacher);
